// ---------------------------------------------------------------------------
// Two doors onto the same rooms.
//
// The studio is a row of benches with every control on them, which is right
// for a creator who knows what a plate is and wrong for one who does not. The
// Quick Studio is the second door: six tabs, one prompt box each, the price
// on the button. Which door somebody last walked through is remembered here.
//
// Unset is a real state, not a default. It means nobody has chosen yet, and
// the landing rule in App.tsx settles it once: a workspace with no show gets
// Quick, one with a show gets Pro. Returning 'pro' for "unset" would take
// that decision away from the landing rule and drop every new creator on the
// board they came here to avoid.
//
// Per browser, like the theme, and for the same reason: it is a property of
// where somebody is sitting. Nothing here touches `document` at module scope,
// so the tests can load it without a DOM.
// ---------------------------------------------------------------------------

export type Mode = 'quick' | 'pro';

const KEY = 'rookery.mode';

export function readMode(): Mode | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'quick' || v === 'pro' ? v : null;
  } catch {
    // Private windows and blocked site data throw on access. The mode is a
    // convenience; failing to read it must never stop the studio loading.
    return null;
  }
}

export function writeMode(m: Mode): void {
  try { localStorage.setItem(KEY, m); } catch { /* see readMode */ }
}
